module.exports = __webpack_public_path__ + "img/wiese.454b7f76.jpg";